<template>
  <el-container>
    <el-aside :width="isCollapse?'20px':'300px'">
      <report-side-bar ref="reportBar" v-bind:myHeight="myHeight" v-bind:isCollapse="isCollapse" v-on:onSearch="onSearch" v-on:doCollapse="doCollapse"></report-side-bar>
    </el-aside>
    <el-main style="padding: 0px">
      <report-list ref="reportList" v-bind:myHeight="myHeight"></report-list>
    </el-main>
  </el-container>
</template>

<script>
  import ReportSideBar from '@/components/ReportSideBar'
  import ReportList from '@/components/ReportList'

  export default {
    data() {
      return {
        isCollapse: false,//是否展开
      }
    },
    props: {
      myHeight: {
        type: Number
      }
    },
    computed: {},
    components: {
      ReportSideBar,
      ReportList
    },
    methods: {
      onSearch(params){
        this.$refs.reportList.loadData(params);
      },
      onresize(){
        this.$refs.reportBar.onresize();
        this.$refs.reportList.onresize();
      },
      //点击"收起/展开"时促发的事件
      doCollapse(isCollapse){
        this.isCollapse = isCollapse;
      }
    },
    watch: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/report/ReportIndex.vue